import { PropTypes } from 'prop-types'

import { Tag } from '@chakra-ui/react'

export const TagSearchItem = ({ tag, url }) => {
  return (
    <Tag.Root
      variant="outline"
      color="label.primary"
      borderRadius="2xl"
      fontSize="2xs"
      px={3}
      py={2}
      css={{ '--shadow-color': 'var(--chakra-colors-gray-500)' }}
      asChild
    >
      <a href={url}>
        <Tag.Label>{tag}</Tag.Label>
      </a>
    </Tag.Root>
  )
}

TagSearchItem.propTypes = {
  tag: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}
